module.exports = __webpack_public_path__ + "static/img/logo.2a05fc6f.png";